import React from 'react';
// import PropTypes from 'prop-types';
import SidebarHeader from '../SidebarHeader';
import SettingsContent from './SettingsContent';
import SettingsFooter from './SettingsFooter';
import { connect } from 'dva';
import X from '../../../assets/svg/Feather/X';

function SettingsSidebar(props) {
  return (
    <>
      <SidebarHeader text="Settings" icon={X} />
      <SettingsContent />
      <SettingsFooter />
    </>
  );
}

SettingsSidebar.propTypes = {

};

export default connect(() => {
  return {};
})(SettingsSidebar);